export class Settings {
    baseUrl: string;
    backendBaseUrl: string;
}
